import { useMemo } from 'react'

import { guessGenderByName } from '../utils'
import type { Gender } from '../types'

/** Реактивная обёртка над `guessGenderByName` — пересчитывается только при смене имени. */
export function useGenderGuess(name: string): Gender | null {
  return useMemo(() => guessGenderByName(name), [name])
}
